<app-input-search
  [isFinishLoadingSubject]="finishLoadingSubject"
  [placeholder]="'Silahkan cari nama batch'"
  [value]="searchInputValue"
  (actionFilter)="handleSearchAction($event)"
></app-input-search>

<div class="ms-auto position-relative">
  <div class="d-flex align-items-center justify-content-center">
    <app-table-content [isFinishLoadingSubject]="finishLoadingSubject" [height]="44" [width]="142">
      <button *ngIf="showAddBatch" mat-raised-button color="primary" class="btn btn-primary" (click)="handleActionAddBatch()">Tambah Batch</button>
    </app-table-content>

    <div class="ms-3">
      <app-filter-table
        [resetLabel]="'Reset Filter'"
        [isFinishLoadingSubject]="finishLoadingSubject"
        [isActiveFilter]="filterInputActivated"
        [isOpenFilter]="filterInputOpened"
        (actionClick)="toggleOpenFilter()"
        (actionReset)="handleResetFilter()"
      >
        <div class="menu menu-sub menu-sub-dropdown w-300px w-md-350px show filter-body" id="kt-toolbar-filter">
          <div class="px-7 py-5">
            <div class="d-flex align-items-center justify-content-between">
              <div class="fs-4 text-dark fw-bold">Filter</div>
              <div>
                <span class="svg-icon svg-icon2 cursor-pointer" [inlineSVG]="STRING_CONSTANTS.ICON.IC_CLOSE_MODAL" (click)="toggleOpenFilter()"></span>
              </div>
            </div>
          </div>
          <div class="separator border-gray-300"></div>

          <form [formGroup]="filterForm" class="form w-100" (ngSubmit)="handleSubmitFilter()">
            <div class="px-7 py-5">
              <div class="mb-5">
                <div class="filter-pills">
                  <mat-chip-listbox #filterPillsBox multiple (change)="handleBatchStatusChange($event)">
                    <ng-container formArrayName="status">
                      <mat-chip-option class="chips" *ngFor="let item of filterPills" [value]="item">
                        <div class="d-flex align-items-center justify-content-between">
                          <span>{{ item }}</span>
                          <span class="custom-x-icon"></span>
                        </div>
                      </mat-chip-option>
                    </ng-container>
                  </mat-chip-listbox>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <button mat-stroked-button (click)="handleResetFilter()" class="btn btn-outline me-4" type="reset" [disabled]="!batchStatusControl.value">
                  <span class="text-primary">Reset</span>
                </button>
                <button mat-raised-button color="primary" class="btn btn-primary" type="submit" [disabled]="!batchStatusControl.value">
                  <span class="text-white">Terapkan</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </app-filter-table>
    </div>
  </div>
</div>
